import React, { ReactNode } from "react";
import { ErrorBoundary } from "@/src/lib/monitoring";
import type { Scope } from "@sentry/browser";
import LayoutError from "@/src/views/layouts/error";

interface MonitoringErrorBoundaryProps {
  children: ReactNode;
  componentName: string;
  fallback?: React.ReactElement;
  onReset?: () => void;
}

export default function MonitoringErrorBoundary({
  children,
  componentName,
  fallback,
  onReset,
}: MonitoringErrorBoundaryProps) {
  const handleBeforeCapture = (scope: Scope) => {
    scope.setTag("source", "ui-error");
    scope.setTag("componentName", componentName);
    scope.setTag(
      "mf_name",
      process.env.NEXT_PUBLIC_MF_NAME || "mf-bribrain-main-desktop"
    );
  };

  return (
    <ErrorBoundary
      beforeCapture={handleBeforeCapture}
      fallback={fallback || <LayoutError />}
      onReset={onReset}
    >
      {children}
    </ErrorBoundary>
  );
}
